const videoExts = ["mp4", "m3u8", "ogg", "vr", "ar"];
const audioExts = ["mp3", "ogg"];
const getMediaType = (ext) => {
  if (ext == null) return null;
  if (videoExts.includes(ext)) return "video";
  if (audioExts.includes(ext)) return "audio";
  return null;
};
const YOUTUBE_RE = /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/i;
const VIMEO_RE = /(?:http|https)?:\/\/(?:www\.|player\.)?vimeo\.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^\/]*)\/videos\/|video\/|)(\d+)(?:|\/\?)/;
function detectHtml5Media(media) {
  const extension = media.split(".").pop();
  const mediaType = getMediaType(extension);
  if (mediaType != null) {
    return {
      provider: "html5",
      mediaType,
      ext: extension,
      url: media
    };
  }
  return null;
}
function detectYoutubeMedia(media) {
  const match = YOUTUBE_RE.exec(media);
  if (match != null) {
    return {
      provider: "youtube",
      id: match[1],
      url: media
    };
  } else if (media.length === 11) {
    return {
      provider: "youtube",
      id: media,
      url: `https://www.youtube.com/watch?v=${media}`
    };
  } else return null;
}
function detectVimeoMedia(media) {
  const match = VIMEO_RE.exec(media);
  if (match != null) {
    return {
      provider: "vimeo",
      id: match[1],
      url: media
    };
  }
  if (/^\d+$/.test(media)) {
    return {
      provider: "vimeo",
      id: media,
      url: `https://vimeo.com/${media}`
    };
  } else return null;
}
const strategies = [
  detectHtml5Media,
  detectYoutubeMedia,
  detectVimeoMedia
];
function detectMedia(media) {
  if (media == null) return null;
  if (typeof media === "number") media = `${media}`;
  for (const strategy of strategies) {
    const result = strategy(media);
    if (result != null) return result;
  }
  return {
    provider: "html5",
    mediaType: "video",
    url: media
  };
}
function getMediaThumbnail(media) {
  const detected = detectMedia(media);
  if (detected != null) {
    switch (detected.provider) {
      case "youtube":
        return `https://img.youtube.com/vi/${detected.id}/0.jpg`;
      case "vimeo":
        return `https://vumbnail.com/${detected.id}_medium.jpg`;
    }
  }
  return null;
}
export {
  detectHtml5Media,
  detectMedia,
  detectVimeoMedia,
  detectYoutubeMedia,
  getMediaThumbnail,
  getMediaType
};
